<template lang="pug">
include /@ibkr/lib.common/src/icon/basic
include /@ibkr/lib.common/src/icon/color
include /@ibkr/lib.common/src/icon/misc
div(class="border-bottom select-regions")
    ib-row
        ib-col(class="xl2")
            p(
                class="insety-16", 
                :class="{'insetx-4': !$media.m, 'insetx-8': $media.l, 'insetx-16': $media.xl}"
            )
                span(
                    class="insetx-8 info", 
                    :class="{'start-0': !$media.m}"
                )
                    +icon-basic-info_filled
                    span(class="tooltext") {{ $t('select_regions') }}
                span {{ $t('regions') }}
        ib-col(
            class="xl10 start-4 end-4",
            :class="{ 'pt-0': !$media.xl, 'start-16': $media.m, 'insety-16': $media.xl, 'pr-0': $media.xl, 'end-16': $media.m }",
        )
            ib-tab-bar(v-model="selectedTab", class="_ga-ib-tab-border-fix")
                ib-tab2(key="a", class="insety-16") {{ $t('global') }}
                ib-tab2(key="b") {{ $t('north_america') }}
                ib-tab2(key="c") {{ $t('south_america') }}
                ib-tab2(key="d") {{ $t('europe') }}
                ib-tab2(key="e") {{ $t('asia') }}
                ib-tab2(key="f") {{ $t('africa') }}
                ib-tab2(key="g") {{ $t('oceania') }}

            div(v-if="selectedTab === 'a'", class="insety-16")
                ib-col(
                    class="xl12 pb-0"
                )
                    ib-button(
                        @click="selectAll('global')",
                        :class="{ active: selectGlobal, fullWidth: !$media.xl }"
                        class="text-left text-bold tab-name after-8",
                    ) 
                        span {{ $t('select_all_regions') }}
                        span(
                            v-if="selectGlobal",
                            class="inset-8 text-left fg-positive"
                        )
                            +icon-color-yes
            div(v-else-if="selectedTab === 'b'", class="insety-16")
                ib-col(
                    class="xl12 pb-0"
                )
                    ib-button(
                        class="text-left text-bold tab-name after-8",
                        @click="selectAll('na')",
                        :class="{ active: selectNA }"
                    )
                        span {{ $t('select_all') }}
                        span(
                            v-if="selectNA",
                            class="inset-8 fg-positive"
                        )
                            +icon-color-yes
                    ib-button(
                        v-for="country in NACountries",
                        :key="country.name",
                        :class="{ active: country.selected }",
                        class="text-left tab-name after-8",
                        @click="select(country.name)"
                    )
                        span {{ $t(country.name) }}
                        span(
                            v-if="country.selected",
                            class="fg-positive"
                        )
                            +icon-color-yes
            div(v-else-if="selectedTab === 'c'", class="insety-16")
                ib-button(
                    @click="selectAll('sa')",
                    :class="{ active: selectSA }",
                    class="text-left text-bold tab-name after-8"
                ) 
                    span {{ $t('select_all') }}
                    span(
                        v-if="selectSA",
                        class="inset-8 fg-positive"
                    )
                        +icon-color-yes
                ib-button(
                    v-for="country in SACountries",
                    :key="country.name",
                    :class="{ active: country.selected }",
                    class="text-left tab-name after-8",
                    @click="select(country.name)"
                ) 
                    span {{ $t(country.name) }}
                    span(
                        v-if="country.selected",
                        class="fg-positive"
                    )
                        +icon-color-yes
            div(v-else-if="selectedTab === 'd'", class="insety-16")
                ib-button(
                    @click="selectAll('eu')",
                    :class="{ active: selectEU }",
                    class="text-left text-bold tab-name after-8"
                )
                    span {{ $t('select_all') }}
                    span(
                        v-if="selectEU",
                        class="inset-8 fg-positive"
                    )
                        +icon-color-yes
                ib-button(
                    v-for="country in EUCountries",
                    :key="country.id",
                    :class="{ active: country.selected }",
                    class="text-left tab-name after-8"
                    @click="select(country.name)"
                ) 
                    span {{ $t(country.name) }}
                    span(
                        v-if="country.selected",
                        class="fg-positive"
                    )
                        +icon-color-yes
            div(v-else-if="selectedTab === 'e'", class="insety-16")
                ib-button(
                    @click="selectAll('ap')",
                    :class="{ active: selectAP }",
                    class="text-left text-bold tab-name after-8 asia"
                )
                    span {{ $t('select_all') }}
                    span(
                        v-if="selectAP",
                        class="inset-8 fg-positive"
                    )
                        +icon-color-yes
                ib-button(
                    v-for="country in APCountries",
                    :key="country.id",
                    :class="{ active: country.selected}",
                    class="text-left tab-name after-8 asia"
                    @click="select(country.name)"
                ) 
                    span {{ $t(country.name) }}
                    span(
                        v-if="country.selected",
                        class="fg-positive"
                    )
                        +icon-color-yes
            div(v-else-if="selectedTab === 'f'", class="insety-16")
                ib-button(
                    @click="selectAll('af')",
                    :class="{ active: selectAF }",
                    class="text-left text-bold tab-name after-8"
                )
                    span {{ $t('select_all') }}
                    span(
                        v-if="selectAF",
                        class="inset-8 fg-positive"
                    )
                        +icon-color-yes
                ib-button(
                    v-for="country in AFCountries",
                    :key="country.id",
                    :class="{ active: country.selected }",
                    class="text-left tab-name after-8",
                    @click="select(country.name)"
                ) 
                    span {{ $t(country.name) }}
                    span(
                        v-if="country.selected",
                        class="fg-positive"
                    )
                        +icon-color-yes
            div(v-else-if="selectedTab === 'g'", class="insety-16")
                ib-button(
                    @click="selectAll('oc')",
                    :class="{ active: selectOC }",
                    class="text-left text-bold tab-name after-8"
                )
                    span {{ $t('select_all') }}
                    span(
                        v-if="selectOC",
                        class="inset-8 fg-positive"
                    )
                        +icon-color-yes
                ib-button(
                    v-for="country in OCCountries",
                    :key="country.id",
                    :class="{ active: country.selected }",
                    class="text-left tab-name after-8",
                    @click="select(country.name)"
                ) 
                    span {{ $t(country.name) }}
                    span(
                        v-if="country.selected",
                        class="fg-positive"
                    )
                        +icon-color-yes
</template>
    
<script>
    import cloneDeep from 'lodash.clonedeep';
    import { mapState, mapActions } from 'vuex';

    export default {
        name: 'RegionTypes',
        methods: {
            selectAll(region) {
                let selected;
                switch(region) {
                    case 'global':
                        selected = !this.selectGlobal;
                        break;
                    case 'na':
                        selected = !this.selectNA;
                        break;
                    case 'sa':
                        selected = !this.selectSA;
                        break;
                    case 'eu':
                        selected = !this.selectEU;
                        break;
                    case 'ap':
                        selected = !this.selectAP;
                        break;
                    case 'af':
                        selected = !this.selectAF;
                        break;
                    case 'oc':
                        selected = !this.selectOC;
                        break;
                }

                const regions = cloneDeep(this.regions);

                regions.forEach(item => {
                    if (region === 'global' || item.region === region) {
                        item.selected = selected;
                    }
                })
                this.setRegions(regions);
            },
            select(name) {
                const index = this.regions.findIndex(item => item.name === name);
                const region = cloneDeep(this.regions[index]);
                region.selected = !region.selected;
                this.setRegion({index, region});

                // Make sure selectAll is set if they chose every region in a tab
                const isAllSelected = this.regions.filter(
                    item => item.region === region.region && item.selected).length === this.regions.filter(item => item.region === region.region).length;
            },
            ...mapActions(['setRegions', 'setSelectedRegionTab', 'setRegion'])
        },
        computed: {
            NACountries: function() {
                return this.regions.filter(item => item.region === 'na');
            },
            SACountries: function() {
                return this.regions.filter(item => item.region === 'sa');
            },
            EUCountries: function() {
                return this.regions.filter(item => item.region === 'eu');
            },
            APCountries: function() {
                return this.regions.filter(item => item.region === 'ap');
            },
            AFCountries: function() {
                return this.regions.filter(item => item.region === 'af');
            },
            OCCountries: function() {
                return this.regions.filter(item => item.region === 'oc');
            },
            selectGlobal: function() {
                return this.regions.length === this.regions.filter(item => item.selected).length;
            },
            selectNA: function() {
                return this.regions.filter(item => item.region === 'na').length === this.regions.filter(item => item.region === 'na').filter(item => item.selected).length;
            },
            selectSA: function() {
                return this.regions.filter(item => item.region === 'sa').length === this.regions.filter(item => item.region === 'sa').filter(item => item.selected).length;
            },
            selectEU: function() {
                return this.regions.filter(item => item.region === 'eu').length === this.regions.filter(item => item.region === 'eu').filter(item => item.selected).length;
            },
            selectAP: function() {
                return this.regions.filter(item => item.region === 'ap').length === this.regions.filter(item => item.region === 'ap').filter(item => item.selected).length;
            },
            selectAF: function() {
                return this.regions.filter(item => item.region === 'af').length === this.regions.filter(item => item.region === 'af').filter(item => item.selected).length;
            },
            selectOC: function() {
                return this.regions.filter(item => item.region === 'oc').length === this.regions.filter(item => item.region === 'oc').filter(item => item.selected).length;
            },
            selectedTab: {
                get: function() {
                    return this.$store.state.selectedRegionTab;
                },
                set: function(newValue) {
                    this.setSelectedRegionTab(newValue);
                }
            },
            ...mapState(['regions', 'selectedRegionTab'])
        },
    }
</script>
<style lang="less">
    ._ga-ib-tab-border-fix {
        border-bottom: 1px solid rgba(0,0,0,.12);
    }

    .fullWidth {
        width: 100%;
    }

    .select-regions {
        button {
            &::after {
                background-color: white;
            }
            svg {
                float: right;
            }
            &:hover {
                border-color: #000;
                .fg-positive {
                    color: #000;
                }
            }
        }
    }

    .plus {
        padding: 8px 7px 8px 12px;
        svg {
            width: 1.25em !important;
            height: 1.25em !important;
        }
        &.fullWidth {
            width: 100%;
        }
        &:hover {
            border-color: #000;
        }
    }

    .pt-0 {
        padding-top: 0;
    }
    .pr-0 {
        padding-right: 0;
    }

    .tab-name {
        min-width: 27%;
        margin-right: 3%;
        &.asia {
            min-width: 45%;
        }
    }

    button {
        border-radius: 0;
        font-size: 0.875rem;
        &::after {
            background-color: #fff;
            opacity: 0;
        }
        svg {
            float: right;
        }
    }
    @media (max-width: 991px) {
        .tab-name {
            width: 100%;
            margin-left: 0;
            margin-right: 0;
        }
    }

    @media (min-width: 601px) and (max-width:991px) {
        .fullWidth {
            text-align: left;
            .bg-inverse {
                float: right;
                padding: 0;
            }
            .fg-positive {
                float: right;
                padding: 0;
            }
        }
    }

    @media (max-width: 600px) {
        .tab-tops {
            ._tabsc {
                margin-bottom: -35px;
                .tablist {
                    overflow-x: scroll;
                }
            }
        }
        button {
            &.fullWidth {
                text-align: left;
                margin-right: 0;
                margin-left: 0;
                .fg-positive {
                    float: right;
                    padding: 0;
                }
                .bg-inverse {
                    float: right;
                }
            }
        }
        .cty-list {
            &.fullWidth {
                text-align: left;
                white-space: normal;
                .fg-positive {
                    float: right;
                    padding: 0;
                }
            }
        }
        .plus {
            &.fullWidth {
                padding-left: 24px;
                padding-right: 16px;
            }
        }
    }
</style>